export const TAG_LABEL_LENGTH = {
  ONE_TAG: 20,
  TWO_OR_MORE: 13,
};

export const TagLabelLength = angular
  .module('sfMobile.constants.tags', [])
  .constant('TAG_LABEL_LENGTH', TAG_LABEL_LENGTH).name;
